import map from "lodash/map";
import { ContentFormatV3 } from "../v3/content_format";
import { TemplateFormatV3 } from "../v3/template_format";
import { ContentFormatV4 } from "../v4/content_format";
import { TemplateFormatV4 } from "../v4/template_format";

export function upgradeContentToV4(contentFormat: ContentFormatV3): ContentFormatV4 {
  return { ...contentFormat, definition_version: 4 };
}

export function upgradeTemplateToV4(templateFormat: TemplateFormatV3): TemplateFormatV4 {
  return {
    ...templateFormat,
    definition_version: 4,
    page_definitions: map(templateFormat.page_definitions, (pageDefinition) => {
      return {
        ...pageDefinition,

        height_dmm: convertMmToDmm(pageDefinition.height_mm),
        width_dmm: convertMmToDmm(pageDefinition.width_mm),

        elements: map(pageDefinition.elements, (element) => {
          const newElement = {
            height_dmm: convertP10KToDmm(pageDefinition.height_mm, element.height),
            width_dmm: convertP10KToDmm(pageDefinition.width_mm, element.width),
            x_dmm: convertP10KToDmm(pageDefinition.width_mm, element.x),
            y_dmm: convertP10KToDmm(pageDefinition.height_mm, element.y),
          };
          switch (element.type) {
            case "editable-picture":
              return {
                ...element,
                ...newElement,
              };
            case "editable-text":
              return {
                ...element,
                ...newElement,
                font_size_dmm: convertP10KToDmm(pageDefinition.height_mm, element.font_size),
                line_height_dmm: convertP10KToDmm(pageDefinition.height_mm, element.line_height),
              };
            case "forced-image":
              return {
                ...element,
                ...newElement,
              };
            case "forced-text":
              return {
                ...element,
                ...newElement,
                font_size_dmm: convertP10KToDmm(pageDefinition.height_mm, element.font_size),
                line_height_dmm: convertP10KToDmm(pageDefinition.height_mm, element.line_height),
              };
            default: {
              const exhaustiveCheck: never = element;
              throw new Error(`Unsupported type "${(exhaustiveCheck as { type: string }).type}"`);
            }
          }
        }),
      };
    }),
    presentation_definitions: map(
      templateFormat.presentation_definitions,
      (presentationDefinition) => {
        const newDefinition: {
          above?: boolean;
          asset_key: string;
          key: string;
          height_dmm: number;
          width_dmm: number;
          content_x_dmm: number;
          content_y_dmm: number;
        } = {
          asset_key: presentationDefinition.asset_key,
          content_x_dmm: convertMmToDmm(presentationDefinition.content_x_mm),
          content_y_dmm: convertMmToDmm(presentationDefinition.content_y_mm),
          height_dmm: convertMmToDmm(presentationDefinition.height_mm),
          key: presentationDefinition.key,
          width_dmm: convertMmToDmm(presentationDefinition.width_mm),
        };
        if (presentationDefinition.above) {
          newDefinition.above = presentationDefinition.above;
        }
        return newDefinition;
      }
    ),
  };
}

function convertMmToDmm(sizeMm: number) {
  return sizeMm * 10;
}

function convertP10KToDmm(sizeP10K: number, reference: number) {
  return (reference * sizeP10K) / 1000;
}
